import { Mm100Page } from '@/components/calculators/power-kits';
import { Appliances, calculateTotalPower } from '@/components/calculators/power-kits/components/Step3/appliances';
import { defaultData } from '@/components/calculators/power-kits/components/Step3/Modal';
import Image from '@/components/UI/Image';
import { message } from '@/components/UI/Message';
import { EFEdit } from '@/components/UI/svg/mm100';
import FixedCalculatorFooter from '@/componentsH5/calculators/components/FixedCalculatorFooter';
import { useGlobal } from '@/utils/useGlobal';
import { Checkbox } from 'antd';
import css from './index.module.scss';
import Modal from './Modal';
export default function Step3H5({ data, callBack }: any) {
    const { useLang, useState, useEffect, gtm, useRouter } = useGlobal();
    const { t } = useLang('shared');
    const { locale } = useRouter();
    const customeAppliance = data?.allAppliances && data?.allAppliances?.find((app: any) => app.key === 'custome');
    const [allAppliances, setAllApplicances] = useState(
        customeAppliance ? data?.allAppliances : data?.allAppliances?.length ? data?.allAppliances : Appliances,
    );
    const [selected, setSelected] = useState(data?.appliances || ([] as any));
    const [editItem, setEditItem] = useState({ item: null, visible: false, type: 'edit' });
    const [customeFlag, setCustomeFlag] = useState(!customeAppliance);
    const [checkedFlag, setCheckedFlag] = useState(Boolean(selected?.length));
    const [totalPower, setTotalPower] = useState(data?.totalPower ?? calculateTotalPower(allAppliances, selected));

    const handleChangeCheck = (app: any, e: any) => {
        if (e.target.checked) {
            const checkedAppliances = [...selected, app];
            callBack({ appliances: checkedAppliances });
            !checkedFlag && setCheckedFlag(true);
            setSelected(checkedAppliances);
            setTotalPower(calculateTotalPower(allAppliances, checkedAppliances));
        } else {
            const checkedAppliances = selected.filter((item: any) => item.key !== app.key);
            callBack({ appliances: checkedAppliances });
            setSelected(checkedAppliances);
            setTotalPower(calculateTotalPower(allAppliances, checkedAppliances));
        }
    };

    const handleEdit = (app: any, type = 'edit') => {
        setEditItem({ item: app, visible: true, type });
    };

    const handleCleanAll = () => {
        callBack({ apppliances: [], totalPower: 0, allAppliances: Appliances });
        setCheckedFlag(false);
        setSelected([]);
        setTotalPower(0);
        setEditItem({ item: null, visible: false, type: 'edit' });
        setAllApplicances(Appliances);
        setCustomeFlag(true);
    };

    const onNext = () => {
        // const keys = selected.map((item: any) => item.key.replace('_', ' '))
        const keys: any = [];
        allAppliances?.map((item: any) => {
            selected?.forEach((ele: any) => {
                if (item.key === ele.key) {
                    keys.push(ele.key.replace('_', ' '));
                }
            });
        });

        gtm.push({
            event: 'uaEvent',
            event_name: 'calculator3',
            step: 'appliance',
            product_name: 'Ecoflow Power Kits',
            option_name: keys,
            button_name: 'Next',
            consumption: `${totalPower}Kwh/day`,
        });
        callBack({
            appliances: selected,
            allAppliances,
            totalPower,
            currentStep: data.currentStep + 1,
            currentPage: Mm100Page.Combo,
        });
    };

    const onBack = () => {
        callBack({
            appliances: null,
            allAppliances: null,
            totalPower: null,
            currentStep: data.currentStep - 1,
            currentPage: data?.scene === 'others' ? Mm100Page.Scenery : Mm100Page.Type,
        });
    };

    const valiConfirm = (item: any) => {
        if (String(Number(item?.power)) === 'NaN' || String(Number(item?.time?.h)) === 'NaN' || String(Number(item?.time?.m)) === 'NaN') {
            return message.error(t(`calculators.mm100.step3.vali_error`));
        }
        if (
            Number(item?.power) <= 0 ||
            Number(item?.time?.h) < 0 ||
            Number(item?.time?.h) > 24 ||
            Number(item?.time?.m) < 0 ||
            Number(item?.time?.m) > 60 ||
            Number(item?.power) % 1 !== 0 ||
            Number(item?.time?.h) % 1 !== 0 ||
            Number(item?.time?.m) % 1 !== 0 ||
            (Number(item?.time?.h) === 24 && Number(item?.time?.m) !== 0) ||
            (Number(item?.time?.h) === 0 && Number(item?.time?.m) === 0)
        ) {
            return message.error(t(`calculators.mm100.step3.vali_error`));
        }
        return true;
    };

    const onModalConfirm = (item: any, type: string) => {
        if (valiConfirm(item)) {
            if (type === 'edit') {
                const newAllAppliances = allAppliances?.map((app: any) => (app.key === item.key ? item : app));
                setAllApplicances(newAllAppliances);
                const newTotalPower = calculateTotalPower(allAppliances, newAllAppliances);
                setTotalPower(newTotalPower);
                callBack({ allAppliances: newAllAppliances, totalPower: newTotalPower });
            }
            if (type === 'add') {
                const newSelected = [...selected, item];
                const newAllAppliances = [...allAppliances, item];
                setSelected(newSelected);
                setAllApplicances(newAllAppliances);
                const newTotalPower = calculateTotalPower(newAllAppliances, newSelected);
                setTotalPower(newTotalPower);
                setCustomeFlag(false);
                callBack({
                    allAppliances: newAllAppliances,
                    appliances: newSelected,
                    totalPower: newTotalPower,
                });
            }
            setEditItem({ item: null, visible: false, type: 'edit' });
        }
    };

    const onModalCancel = () => {
        setEditItem({ item: null, visible: false, type: 'edit' });
    };

    useEffect(() => {
        setTotalPower(calculateTotalPower(allAppliances, selected));
    }, [allAppliances]);

    const generateDesc = (app: any) => {
        return `${app?.power}W/${Number(app?.time?.h) ? Number(app?.time?.h) + t('calculators.mm100.step3.time_h_s') : ''}${
            Number(app?.time?.h) && Number(app?.time?.m) ? ' ' : ''
        }${Number(app?.time?.m) ? app?.time?.m + t('calculators.mm100.step3.time_m_s') : ''}${t('calculators.mm100.step3.per_day')}`;
    };

    return (
        <div className={`step3H5 ${css.step3H5}`}>
            <h2 className="step3-title">
                {t('calculators.mm100.step3.title', {
                    type: t(`calculators.mm100.step1.${data?.scene}`),
                })}
            </h2>
            <p className="cleanAll" onClick={handleCleanAll}>
                {t('calculators.mm100.step3.clean')}
            </p>
            <ul className="step3-appliances">
                {allAppliances?.map((app: any, k: number) => (
                    <li className={`step3-appliance ${selected?.find((item: any) => item.key === app.key) ? 'active' : ''}`} key={k}>
                        <div className="app-icon">
                            <Image
                                src={app?.icon}
                                layout="fill"
                                className="fullImgs"
                                alt={t(`calculators.mm100.step3.${app.i18n}`)}
                                aria-label={t(`calculators.mm100.step3.${app.i18n}`)}
                            />
                        </div>
                        <div className="app-text">
                            <p className="name">{t(`calculators.mm100.step3.${app?.i18n}`)}</p>
                            <p className="power">{generateDesc(app)}</p>
                        </div>
                        <div className="editBtn" onClick={() => handleEdit(app)}>
                            {/* {t('calculators.mm100.step3.edit')} */}
                            <EFEdit />
                        </div>
                        <div className="checkBox">
                            <Checkbox
                                checked={selected?.find((item: any) => item.key === app.key) ? true : false}
                                onChange={(e: any) => handleChangeCheck(app, e)}
                            />
                        </div>
                    </li>
                ))}
                {customeFlag && (
                    <li className="custome-appliance step3-appliance" onClick={() => handleEdit(defaultData, 'add')}>
                        <div className="app-icon">
                            <Image
                                src="/img/calculators/mm100/appliance_custom.svg"
                                layout="fill"
                                className="fullImgs"
                                alt={t(`calculators.mm100.step3.custome`)}
                                aria-label={t(`calculators.mm100.step3.custome`)}
                            />
                        </div>
                        <div className="app-text">
                            <p className="name">{t(`calculators.mm100.step3.custome`)}</p>
                        </div>
                        <div className="plusBtn">+</div>
                    </li>
                )}
            </ul>
            <p className="step3-desc">{t(locale === 'kr' ? 'calculators.mm100.step3.desc_h5' : 'calculators.mm100.step3.desc')}</p>
            <FixedCalculatorFooter>
                <p className="step3-totalPower">
                    <span className="consumption">{t('calculators.mm100.step3.comsuption')}</span>
                    <span className="totalPower">
                        {Math.round(totalPower * 100) / 100}
                        {t('calculators.mm100.step3.unit')}
                    </span>
                </p>
                <button className={`step2H5-prevBtn step2Btn commonPrev`} onClick={onBack}>
                    {t('calculators.mm100.back')}
                </button>
                <button
                    className={`step2H5-nextBtn step2Btn commonNext ${selected?.length && totalPower ? 'active' : ''}`}
                    onClick={onNext}
                    disabled={!selected?.length}
                >
                    {t('calculators.mm100.next')}
                </button>
            </FixedCalculatorFooter>
            <Modal config={{ visible: editItem.visible }} item={editItem.item} type={editItem.type} onConfirm={onModalConfirm} onCancel={onModalCancel} />
        </div>
    );
}
